import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField,
    ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Event_Type_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_EVTTYPE_ID: {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Event Type WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    TYPE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Event Type Id',    columnResourceName: 'colEventTypeId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
    TYPE_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name',             columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
    SOURCE_ID:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID',        columnResourceName: 'colSourceID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}}
}

const EventTypeSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_EVTTYPE_ID',
                id_ui: 'TYPE_ID',
                name:  'TYPE_NAME'},


    searchProviderFields: vUI_Event_Type_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        const self = this
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Event_Type_Search',
                self.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var EventTypeSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "EventTypeSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'TYPE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'TYPE_NAME', renderOptions: { }}
    ],  // ISearchFields

    profileDisplayFields: [
        'TYPE_ID','TYPE_NAME','SOURCE_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: EventTypeSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const EventTypeSearch: ISearch = {
    searchName: "Find Event Type",
    renderOptions: { ui5ResourceId: "EventTypeSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [EventTypeSearchProfileByName]
}

PAEnvironment.registerBusinessObjectSearch("EventTypeBO", "EventType", EventTypeSearch, "Event Type Search")

export {EventTypeSearch}